<template>
  <div class="tab-content tab-view-list">
    <list-form ref="listForm" :config="listFormConfig" :formModel="getListFormModel">
      <template v-slot="{ data, updateDataItem, updateModelItem }">
        <form-details
          :companyID="companyID"
          :disabled="!isAvailableToEdit"
          :data="data"
          :model="getListFormModel"
          :config="{ id: listFormConfig.id }"
          @change="updateDataItem($event)"
          @updateModelItem="updateModelItem"
        />
      </template>
    </list-form>
    <editor
      :config="{id: listFormConfig.id}"
      :companyID="companyID"
    ></editor>
  </div>
</template>

<script>
import Tab from './../Tab'
import ListFormConfig from './ListFormCinfig'
import { waitValue } from '@/utils/promises'

export default {
  name: 'TabDetails',
  mixins: [Tab],
  components: {
    'form-details': () => import(/* webpackChunkName: 'Companies' */ './Form'),
    'list-form': () => import(/* webpackChunkName: 'ListForm' */ '@/components/ListForm/Index.vue'),
    'editor': () => import(/* webpackChunkName: 'Companies' */ './Editor.vue')
  },
  data () {
    return {
      listFormConfig: ListFormConfig
    }
  },
  methods: {
    getListForm () {
      return waitValue(() => this.$refs.listForm)
    },
    getListFormModel () {
      return {
        id: null,
        companyID: null,
        companyTypeID: null,
        street: '',
        city: '',
        remark: '',
        country: '',
        zipCode: '',
        fax: '',
        state: '',
        phone: '',
        addressTypeDivisionID: null,
        email: '',
        scoreID: null,
        vatNumber: '',
        baxEmployeeID: null
      }
    },
    // Mixin Tabs
    handleChangeCompanyID (companyID) {
      this.getListForm()
        .then((listForm) => {
          if (!companyID) return
          listForm.setFilters(`companyID == ${companyID}`)
          listForm.loadData()
        })
    }
  }
}
</script>
